// eslint-disable-next-line no-shadow
export enum HubriseRightAccess {
    READ = 'read',
    WRITE = 'write',
}
